/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmcPoolOrgRequestStateEnum } from './vmcPoolOrgRequestStateEnum';
import { VmcPoolOrgOperationEnum } from './vmcPoolOrgOperationEnum';


export interface VmcPoolRequest { 
    approval_required: boolean;
    completed_time?: Date;
    created_by_user: string;
    created_time: Date;
    /**
     * Primary Key
     */
    id: number;
    operation: VmcPoolOrgOperationEnum;
    org_id: string;
    reviewed_by_user?: string;
    reviewed_time?: Date;
    spec: string;
    state: VmcPoolOrgRequestStateEnum;
    task_id: string;
    vmc_org_id: string;
}
export namespace VmcPoolRequest {
}


